import { SkeletonLoader } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledLoader = styled(SkeletonLoader).attrs({
  areas: [
    {
      styles: {
        width: '180px',
        height: '25px',
        borderRadius: '8px',
      },
    },
  ],
})``;
